import React from 'react';
import { Star } from 'lucide-react';

interface TestimonialCardProps {
  content: string;
  author: string;
  role: string;
  rating: number;
  imageUrl?: string;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  content,
  author,
  role,
  rating,
  imageUrl,
}) => {
  return (
    <div className="bg-light rounded-lg p-6 shadow-custom hover:shadow-custom-hover transition-all duration-300 flex flex-col h-full">
      <div className="flex mb-4">
        {[...Array(5)].map((_, i) => (
          <Star 
            key={i} 
            className={`h-5 w-5 ${i < rating ? 'text-primary fill-primary' : 'text-medium-gray'}`} 
            strokeWidth={1.5} 
          />
        ))}
      </div>
      <p className="text-dark-gray mb-6 flex-grow italic">"{content}"</p>
      <div className="flex items-center mt-auto">
        {imageUrl ? (
          <img src={imageUrl} alt={author} className="h-12 w-12 rounded-full mr-4 object-cover" />
        ) : (
          <div className="h-12 w-12 rounded-full bg-secondary/20 text-secondary flex items-center justify-center mr-4 font-medium text-lg">
            {author.charAt(0)}
          </div>
        )}
        <div>
          <p className="font-abadi font-medium">{author}</p>
          <p className="text-dark-gray text-sm">{role}</p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;